// Pure helpers for the AI search box — extracted from Home.tsx so they can be unit tested.

// The token currently being typed (last whitespace-separated word), lowercased.
export const currentToken = (query: string): string =>
    (query.trim().split(/\s+/).pop() || '').toLowerCase();

// Filter the vocabulary by the token being typed. Empty token -> full list.
export const filterSkillOptions = (skills: string[], query: string): string[] => {
    const token = currentToken(query);
    if (!token) { return skills; }
    return skills.filter((s) => s.toLowerCase().includes(token));
};
